import React, { useState } from 'react';
import { Box, Container, Step, StepLabel, Stepper } from '@mui/material';
import {
    StepIdentification,
    StepAdresseClassification,
    StepContacts,
} from '../../components/CreatePrescripteur';

const STEPS = ['Identification', 'Informations', 'Contacts'];

const CreatePrescripteurStepper: React.FunctionComponent = function () {
    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => setActiveStep((prev) => prev + 1);
    const handleBack = () => setActiveStep((prev) => prev - 1);

    const renderStep = () => {
        switch (activeStep) {
            case 0:
                return <StepIdentification onNext={handleNext} />;
            case 1:
                return (
                    <StepAdresseClassification
                        onNext={handleNext}
                        onBack={handleBack}
                    />
                );
            case 2:
                return <StepContacts onBack={handleBack} />;
            default:
                return null;
        }
    };

    return (
        <Container maxWidth="md">
            <Box mt={4}>
                <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    sx={{ mb: 4 }}
                >
                    {STEPS.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {renderStep()}
            </Box>
        </Container>
    );
};

export default CreatePrescripteurStepper;
